module.exports = __webpack_public_path__ + "static/images/components/Nation/images/flag-cn-sweden.8375df97.png";


//////////////////
// WEBPACK FOOTER
// ./components/Nation/images/flag-cn-sweden.png
// module id = 2631
// module chunks = 11